import { render, staticRenderFns } from "./Grade6ExamResult.vue?vue&type=template&id=01da9199&scoped=true&"
import script from "./Grade6ExamResult.vue?vue&type=script&lang=js&"
export * from "./Grade6ExamResult.vue?vue&type=script&lang=js&"
import style0 from "./Grade6ExamResult.vue?vue&type=style&index=0&id=01da9199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01da9199",
  null
  
)

export default component.exports